import TextInput from '../text-input'
import WithInputIdAndName from './with-input-id-and-name'

export default {
  components: { TextInput },

  mixins: [ WithInputIdAndName ],

  props: {
    entityName: {
      type: String,
      required: true
    },

    maxLength: {
      type: Number,
      required: false
    },

    minLength: {
      type: Number,
      required: false
    },

    required: {
      type: Boolean,
      required: false
    },

    validationErrors: {
      type: Array,
      required: false,
      default: () => []
    },

    value: {
      type: String,
      required: false
    }
  },

  emits: ['changed'],

  methods: {
    changed(newValue) {
      this.$emit('changed', newValue)
    }
  }
}
